<template>
    <q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; min-height: 80vh; max-height: 80vh;'">
        <q-toolbar>
            <q-toolbar-title>{{ $t('download_our_app') }}</q-toolbar-title>

            <q-btn flat round dense icon="fal fa-times" v-close-popup />
        </q-toolbar>

        <q-separator /> 
        <q-card-section :class="$q.platform.is.mobile ? '' : 'q-px-xl q-pb-xl'">
            <q-table
                :rows="codes"
                @request="getAll"
                :loading="loading"
                :columns="columns"
                :no-data-label="$t('no_data_avaliable')"
                :no-results-label="$t('no_results_found')"
                :loading-label="$t('loading_data')"
                :rows-per-page-label="$t('items_per_page')"
                :rows-per-page-options="[1, 20, 100]"
                grid
                row-key="code"
                binary-state-sort
                card-container-class="flex justify-center"
                >

                <template v-slot:top-right>
                      <q-btn color="primary" icon="far fa-plus" @click="generateCode()" :label="$t('new_download_code')"/>
                </template>

                <template v-slot:item="props">
                    <q-card class="q-ma-md">
                        <q-card-section key="redemption_link" :props="props" class="column">
                            <span class="text-h6 text-center">{{$t('download_app')}}</span>
                            <q-btn flat icon="fal fa-download" size="24px" color="primary" @click="openLink(getlink(props.row.redemption_link))" />
                        </q-card-section>
                        <q-card-section key="code" class="column" :props="props">
                            <span class="text-center">{{$t('redemption_code')}}</span>
                            <span class="text-center text-bold">{{ props.row.code }}</span>
                        </q-card-section>
                    </q-card>
                </template>
                
            </q-table>

        </q-card-section>
    </q-card>
</template>
<script>
import { Plugins } from '@capacitor/core'
const { Browser } = Plugins

export default {
    name: 'AppleCodes',

    data() {
        return {
            codes: [],
            not_used:0,
            columns: [
                {
                    name: 'redemption_link',
                    required: true,
                    label: 'download',
                    align: 'left',
                    field: 'redemption_link',
                    sortable: false,
                },
                {
                    name: 'code',
                    required: true,
                    label: 'redemption_code',
                    align: 'left',
                    field: 'code',
                    sortable: false,
                }
            ],
            loading: false
        }
    },

    methods: {

        getAll() {
            this.$q.loading.show()

            this.$axios.all([this.listCodes(), this.infoCode()])
            .then(this.$axios.spread((response, info) => {

                this.codes = response.data.map(e => {
                    return {
                        code: e.code,
                        redemption_link: e.code
                    }
                })
                this.codes.reverse()
                this.not_used = info.data.not_used

			}))
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                if (this.codes.length === 0) this.generateCode()
                else this.$q.loading.hide()
            })
        },

        listCodes() {
            return this.$axios.get(`/admin_import/codes_app/list_user_code/`)
        },

        infoCode() {
            return this.$axios.get(`/admin_import/codes_app/qty_code/`)
        },

        generateCode() {
            this.$q.loading.show()

            if(this.not_used == 0){
                this.$q.notify({
                    message: this.$t('there_are_no_codes_available'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                })
                this.$q.loading.hide()
                return
            }

            this.$axios.post(`/admin_import/apple_code/`, {})
            .then(response => {
               this.getAll()
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        getlink(code) {
          return `itmss://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/freeProductCodeWizard?code=${code}`
        },

        openLink(link) {
            if (this.$q.platform.is.capacitor && this.$q.platform.is.ios) {
                Browser.open({ url: link })
            }
            else {
                window.open(link, '_blank')
            }
        }
    },

    created() {
        this.getAll()
    }
}
</script>

<style>

</style>